import AuthContentWrapper from "./components/AuthContentWrapper";
import { C2Text, C3Text, T1Text } from "../../common/components/text/CustomText";
import { Column, Padding, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import CustomInput from "../../common/components/input/CustomInput";
import { useRef, useState } from "react";
import CustomCheckbox from "../../common/components/checkbox/CustomCheckbox";
import { useNavigate } from "react-router-dom";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import Translate from "../../common/translate/Translate";
import CustomPopup from "../../common/components/popup/CustomPopup";
import ValidUtil from "../../common/utils/ValidUtil";
import AuthService from "../../service/AuthService";
import CustomIcon from "../../common/components/image/CustomIcon";
import LocalStorageKey from "../../common/enums/LocalStorageKey";
import { Theme } from "../../common/Theme";

function LoginPage() {
    const navigate = useNavigate();
    const service = new AuthService();

    const [username, setUsername] = useState(localStorage.getItem(LocalStorageKey.rememberUsername) || "");
    const [password, setPassword] = useState("");
    const [isRememberMe, setIsRememberMe] = useState(!!localStorage.getItem(LocalStorageKey.rememberUsername));

    // api 에러 팝업
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    // 다회차 로그인 실패 팝업
    const [isManyTimesLoginFailPopupOpened, setIsManyTimesLoginFailPopupOpened] = useState(false);
    const redirectUrl = useRef("");

    // valid
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isPasswordValid, setIsPasswordValid] = useState(true);

    async function handleLogin() {
        if (!(username.length > 0 && password.length > 0)) {
            setIsEmailValid(false);
            setIsPasswordValid(false);
            return;
        } else if (!ValidUtil.isValidEmail(username)) {
            setIsEmailValid(false);
            setIsPasswordValid(true);
            return;
        }
        setIsEmailValid(true);
        setIsPasswordValid(true);

        try {
            await service.login({ userid: username, password: password });

            if (isRememberMe) {
                localStorage.setItem(LocalStorageKey.rememberUsername, username);
            } else {
                localStorage.removeItem(LocalStorageKey.rememberUsername);
            }

            navigate("/dashboard");
        } catch (error) {
            if (error.message.toString().startsWith("/auth/login-lock?userId=")) {
                redirectUrl.current = error.message.toString();
                setIsManyTimesLoginFailPopupOpened(true);
                return;
            } else if (error.message.toString().startsWith("/")) {
                navigate(error.message.toString());
            }
            setPopupMessage(error.message);
            setIsPopupOpened(true);
        }
    }

    function handleHistoryBack() {
        navigate("/auth");
    }

    return (
        <AuthContentWrapper contentPadding={"20px"}>
            <CustomIcon iconName={"undo"} size={"36px"} onClick={handleHistoryBack} cursor={"pointer"} />
            <SizedBox height={"6px"} />
            <Padding padding={"6px 42px 44px"}>
                <Column justifyContent={"center"}>
                    <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                        {Translate("common.laundryCrew")} {Translate("role.admin")}
                    </T1Text>
                    <SizedBox height={"10px"} />
                    <C2Text fontColor={Theme.color.gray500}>{Translate("auth.login.subtitle")}</C2Text>
                    <SizedBox height={"44px"} />
                </Column>
                <C2Text fontWeight={"500"}>{Translate("auth.id")}</C2Text>
                <SizedBox height={"6px"} />
                <CustomInput
                    placeholder={Translate("placeholder.id")}
                    type={"email"}
                    inputType={"email"}
                    padding={"15px 16px"}
                    inputValue={username}
                    setInputValue={setUsername}
                    isValid={isEmailValid}
                />
                <SizedBox height={"16px"} width={"100%"} />
                <C2Text fontWeight={"500"}>{Translate("auth.password")}</C2Text>
                <SizedBox height={"6px"} />
                <CustomInput
                    placeholder={Translate("placeholder.password")}
                    type={"password"}
                    padding={"14px 16px"}
                    inputValue={password}
                    setInputValue={setPassword}
                    isValid={isPasswordValid}
                />
                <SizedBox height={"21px"} />
                <Row width={"100%"} justifyContent={"space-between"}>
                    <Row>
                        <CustomCheckbox checked={isRememberMe} onClick={() => setIsRememberMe(!isRememberMe)} />
                        <SizedBox width={"8px"} />
                        <C3Text fontWeight={"500"}>{Translate("auth.login.rememberMe")}</C3Text>
                    </Row>
                    <C3Text
                        fontWeight={"500"}
                        fontColor={Theme.color.indigo700}
                        cursor={"pointer"}
                        onClick={() => navigate("/auth/reset-password/request")}
                    >
                        {Translate("auth.login.forgotPassword")}
                    </C3Text>
                </Row>
                <SizedBox height={"20px"} />
                <FullWidthButton onClick={handleLogin} text={Translate("auth.login.signIn")} />
                <SizedBox height={"28px"} />
                <Column justifyContent={"center"}>
                    <Row>
                        <C3Text fontWeight={"400"}>{Translate("auth.login.joinSentence")}</C3Text>
                        <SizedBox width={"8px"} />
                        <C3Text fontWeight={"500"} cursor={"pointer"} onClick={() => navigate("/auth/terms")}>
                            {Translate("auth.login.signUp")}
                        </C3Text>
                    </Row>
                </Column>
            </Padding>
            <CustomPopup isOpen={isPopupOpened} onConfirm={() => setIsPopupOpened(false)} message={popupMessage} />
            <CustomPopup
                isOpen={isManyTimesLoginFailPopupOpened}
                onConfirm={() => {
                    setIsManyTimesLoginFailPopupOpened(false);
                    navigate(redirectUrl.current);
                }}
                message={
                    "Incorrect information was entered on several occasions while attempting to sign in to this account"
                }
            />
        </AuthContentWrapper>
    );
}

export default LoginPage;
